var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.3801 5.555C42.0634 5.20167 41.6117 5 41.1384 5H8.86174C8.3884 5 7.93674 5.20167 7.62007 5.555C7.3034 5.90833 7.1534 6.38 7.20507 6.85L10.8751 39.8883C10.9484 40.56 11.4234 41.1217 12.0734 41.3067L24.5401 44.8683C24.6901 44.9117 24.8451 44.9333 24.9984 44.9333C25.1517 44.9333 25.3067 44.9117 25.4567 44.8683L37.9234 41.3067C38.5734 41.1217 39.0467 40.56 39.1217 39.8883L42.7934 6.85C42.8467 6.38 42.6967 5.90833 42.3801 5.555ZM34.1934 21.79L33.4501 33.9317L25.0534 36.6767L16.6567 33.9317L16.3384 28.125H20.5884L20.6951 30.765L25.0534 32.2433L29.4117 30.765L29.7301 26.015H20.3767L20.1651 21.7917H29.9434L30.2617 17.5683H15.5934L15.2751 13.3433H34.7251L34.1934 21.79Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/CSS3.3290e9f58a710de71db27ca7a00a89db.svg";
export { ForwardRef as ReactComponent };